import React from "react";

const CompanyForm = () => {
  return <div>CompanyForm</div>;
};

export default CompanyForm;
